/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { Extension } from '../../core/models/Extension';
import { NodePath } from '../../core/models/NodePath';

/**
 * A command used to delete a single extension.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteExtensionCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _name : string;

    public _hasOldValue : boolean;

    public _oldValue : any;

    public constructor(extension? : any) {
        if(((extension != null && extension instanceof <any>Extension) || extension === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
            (() => {
                this._parentPath = Library.createNodePath(extension.parent());
                this._name = extension.name;
            })();
        } else if(extension === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteExtensionCommand] Executing.");
        this._oldValue = null;
        this._hasOldValue = false;
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let extension : Extension = parent.getExtension(this._name);
        if(ModelUtils.isDefined(extension)) {
            this._hasOldValue = true;
            this._oldValue = extension.value;
            parent.removeExtension(this._name);
        } else {
            this._hasOldValue = false;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteExtensionCommand] Reverting.");
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let extension : Extension = parent.getExtension(this._name);
        if(this._hasOldValue && ModelUtils.isDefined(extension)) {
            extension.value = this._oldValue;
        }
        if(this._hasOldValue && this.isNullOrUndefined(extension)) {
            let ext : Extension = parent.createExtension();
            ext.name = this._name;
            ext.value = this._oldValue;
            parent.addExtension(this._name, ext);
        }
    }
}
DeleteExtensionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteExtensionCommand";
DeleteExtensionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

